import { ReactNode } from 'react'

import {
  GridRow,
  GridTable,
  GridTable2,
  StyledListItem,
  StyledList,
  StyledListInGridRow,
  ZenkakuSpace,
} from '../TextStyle'
import { LinkText } from '@/components/elements/LinkText'

export const pvItems: { children: ReactNode; id: string }[] = [
  {
    children: (
      <>
        <h3>1. Collection and Management of Personal Information</h3>
        <p>
          TRIAL Group asks Customers to register their personal information after confirming the purpose of use for Customers to use services. Personal information collected during purchases, inquiries, etc. is strictly managed to prevent unauthorized access, loss, falsification, leakage, etc. Specifically, TRIAL Group has implemented the following security control measures.
        </p>
        <StyledList liWidth="960" marginLeft="1.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            Appoint the persons responsible for the handling of personal information at each company within the TRIAL Group.
          </StyledListItem>
          <StyledListItem listType="article">
            Clarify the employees who handle personal information as well as the scope of personal information handled by such employees and establish a system for reporting to and contacting the person in charge in case of ascertaining facts or indications of the violation of the Personal Information Protection Acts or internal regulation regarding the handling of personal information.
          </StyledListItem>
          <StyledListItem listType="article">
            Regularly educate employees about matters of concern regarding the handling of personal information.
          </StyledListItem>
          <StyledListItem listType="article">
            Implement measures to prevent unauthorized persons from viewing personal information in areas where personal information is handled.
          </StyledListItem>
          <StyledListItem listType="article">
            Implement access control to limit the persons in charge and the scope of personal information handled.
          </StyledListItem>
        </StyledList>
        <p>
          Personal information collected by TRIAL Group is information that can identify a specific individual (such as name, address, telephone number, fax number, e-mail address, etc.) provided by the Customers, etc.  at the time of various inquiries, procedures, or submission of various certifications and official documents. Personal information also includes information that may not be used to identify a specific individual by itself but may be easily cross-checked with other information to identify a specific individual as a result.
          <br />
          Although sufficient security measures are taken on the Websites to protect personal information from unauthorized access, leakage, falsification, destruction, etc., these measures do not apply to the process by which the signal reaches the Websites from the Customers&apos; computers. 
          Customers are required to manage the security by themselves.
        </p>
      </>
    ),
    id: 'privacy1',
  },
  {
    children: (
      <>
        <h3>2. Purpose of Use</h3>
        <p>
          Personal information of the Customers managed by TRIAL Group shall not be used beyond the following purposes without the prior consent of the Customers.
        </p>
        <StyledList liWidth="960" marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            Confirmation and fulfillment of transactions related to products and services, etc.
          </StyledListItem>
          <StyledListItem listType="article">
            Delivery procedures for ordered products, checked packages, etc.
          </StyledListItem>
          <StyledListItem listType="article">
            Screening of TRIAL prepaid card membership applications.
          </StyledListItem>
          <StyledListItem listType="article">
            Confirmation and cancellation of reservations for products and services, etc.
          </StyledListItem>
          <StyledListItem listType="article">
            After-sales service related to products and services, etc.
          </StyledListItem>
          <StyledListItem listType="article">
            Management of purchase points and usage status.
          </StyledListItem>
          <StyledListItem listType="article">
            Planning and implementation of events, campaigns, benefits, preferential treatment, discounts, and similar initiatives regarding products and services, etc. of TRIAL Group or third parties.
          </StyledListItem>
          <StyledListItem listType="article">
            Shipping of products related to events, campaigns, benefits, preferential treatment, etc. regarding products and services, and similar initiatives of TRIAL Group or third parties.
          </StyledListItem>
          <StyledListItem listType="article">
            Confirmation of the contents of inquiries or comments and provision of customer support.
          </StyledListItem>
          <StyledListItem listType="article">
            Advertisements or other marketing activities related to products and services, etc. of TRIAL Group or third parties and delivery and distribution of information materials, mail magazines, and direct mail.
          </StyledListItem>
          <StyledListItem listType="article">
            Implementation of questionnaires related to  products and services, etc of TRIAL Group or third parties.
          </StyledListItem>
          <StyledListItem listType="article">
            Development, improvement, and research on products and services, etc.
          </StyledListItem>
          <StyledListItem listType="article">
            Implementation of various recruitment events, recruitment selection, and employment management for employees.
          </StyledListItem>
          <StyledListItem listType="article">
            Maintenance and management of facilities and equipment.
          </StyledListItem>
          <StyledListItem listType="article">
            Payment settlement and credit management.
          </StyledListItem>
          <StyledListItem listType="article">
            Market research, ascertainment of sales floor conditions, analysis of customer trends, analysis of the use of products and services, etc., and other research and analyses necessary for management as well as the preparation of data for such purposes (including the preparation of various statistical information).
          </StyledListItem>
          <StyledListItem listType="article">
            Crime prevention and safety measures, fraud detection and the measures taken for the fraud.
          </StyledListItem>
          <StyledListItem listType="article">
            Purposes of use separately disclosed to Customers or publicly announced.
          </StyledListItem>
          <StyledListItem listType="article">
            Management of shareholders and providing information for shareholders in accordance with the Companies Act, etc.
          </StyledListItem>
          <StyledListItem listType="article">
            Notifications related to the above and other emergency contacts.
          </StyledListItem>
          <StyledListItem listType="article">Purposes incidental to the above.</StyledListItem>
          <p>
            *As part of the marketing activities in (10), the TRIAL Group may link user lists including Customers, etc., held by Google, LINE, and other advertisement-related operators (hereinafter referred to as &quot;Advertisement-related Operators&quot;) (limited to lists of users for whom the Advertisement-related Operators have obtained prior consent for third-party provision), with information held by the TRIAL Group such as e-mail addresses, telephone numbers, cookies, and other information necessary to identify users, in order to provide suggestions, information, and advertisement distribution regarding the services of the TRIAL Group or third parties (hereinafter referred to as &quot;Suggestions, etc.&quot;) to users who meet certain conditions (including users of the TRIAL Group&apos;s services and services provided by Advertisement-related Operators).
            <br />
            <br />
            In addition, as part of the marketing activities in (10), the TRIAL Group may acquire personally referable information such as cookies, location information, and advertising identifiers from Advertisement-related Operators, and may provide Suggestions, etc., to Customers, etc., by linking such personally referable information with the personal information of Customers, etc., already held by the TRIAL Group. When performing such linking, the TRIAL Group shall do so only after obtaining prior consent from the subject Customers, etc.
          </p>
        </StyledList>
      </>
    ),
    id: 'privacy2',
  },
  {
    children: (
      <>
        <h3>3. Jointly Utilization of Personal Information</h3>
        <p>
          TRIAL Group and SU-PAY Co., Ltd. may jointly utilize the personal information in their possession within TRIAL Group with appropriate protection measures within the scope of &quot;2. Purpose of Use&quot; as set forth below.
          <br />
          *Click <LinkText path="/en/legal/privacy-policy/joint-utilization" text="here" /> for information on the joint utilization of personal information between TRIAL Group and SU-PAY Co., Ltd.
        </p>
      </>
    ),
    id: 'privacy3',
  },
  {
    children: (
      <>
        <h3>4. Provision to Third Parties</h3>
        <StyledList liWidth="960" marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            TRIAL Group may outsource all or part of the handling of acquired personal information to third parties to the extent necessary to achieve the purpose of use. In such cases, TRIAL Group shall conclude necessary contracts such as contracts for the protection of personal information and implement necessary and appropriate supervision of such third parties.
          </StyledListItem>
          <StyledListItem listType="article">
            For the purpose of use set forth in Article 2, TRIAL Group may provide personal information and personally referable information of Customers, etc. to third parties after obtaining prior consent from Customers, etc.
          </StyledListItem>
          <StyledListItem listType="article">
            TRIAL Group shall not provide collected personal information to third parties, except in the case set forth in the preceding paragraphs of this Article or in the case of joint use. However, this shall not apply in cases where consent has been obtained by the Customers,etc. or permitted by law.
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'privacy4',
  },
  {
    children: (
      <>
        <h3>5. Provision to Third Parties Located in Foreign Countries</h3>
        <p>
          When TRIAL Group provides personal information to third parties located in foreign countries, TRIAL Group shall take necessary measures such as obtaining consent in accordance with laws and regulations.
        </p>
      </>
    ),
    id: 'privacy5',
  },
  {
    children: (
      <>
        <h3>6. Use of Anonymously Processed Information</h3>
        <p>
          TRIAL Group may produce anonymously processed information based on personal information provided by Customers, which is processed in such a way individuals shall not be identified. TRIAL Group shall comply with the following points regarding the handling of anonymously processed information.
        </p>
        <StyledList liWidth="960" marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="boldArticle">
            Matters Concerning Safety Control Measures
            <p>
              TRIAL Group shall take necessary and appropriate security control measures for the management of anonymously processed information, including the prevention of leakage, loss, or damage.
            </p>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            Matters Concerning Anonymously Processed Information Produced by TRIAL Group
            <p>
              ① TRIAL Group produces anonymously processed information based on the information provided and provides it to third parties on an ongoing basis.
            </p>
            <StyledList liWidth="960" marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="boldArticle">
                Items of Personal Information (items included in anonymously processed information)
                <p>
                  Attribute information（Gender, age categories, store visit distance, temporary ID (a substituted identifier from which the  TRIAL Member ID cannot be restored), family structure, caregiver/non-caregiver status, business/non-business status, matters concerning interests, etc.) and purchase information （date of purchase, store number, store name, products name, purchase quantity, and purchase amount）.
                </p>
              </StyledListItem>
              <StyledListItem listType="boldArticle">
                Method of provision
                <p>Method of Uploading to the Password-protected Server</p>
              </StyledListItem>
            </StyledList>
            <p>
              ② If TRIAL Group produces anonymously processed information other than (1) in ① above, TRIAL Group shall disclose the items of information related to individuals contained in the anonymously processed information.
            </p>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            Matters Concerning Anonymously Processed Information to be Provided to Third Parties
            <p>
              Except in the case of “(2) Matters Concerning Anonymously Processed Information Produced by TRIAL Group”, when providing anonymously processed information to a third party, TRIAL Group shall disclose the items of information concerning individuals included in the anonymously processed information to be provided and the method of provision.
            </p>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            Prohibition of Identification 
            <p>
              With respect to anonymously processed information, TRIAL Group shall not obtain information regarding the description deleted from the personal information or individual identification codes, or any information regarding the method of processing and shall not collate the anonymously processed information with other information in order to identify a principal concerned with personal information used to produce such anonymously processed information.
            </p>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            Contact for Inquiries and Complaints
            <p>
              Please contact us with the information of &quot;13. Contact for Inquiries about Personal Information&quot; of the Privacy Policy.
            </p>
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'privacy6',
  },
  {
    children: (
      <>
        <h3>7. Use of Cookies</h3>
        <p>
        TRIAL Group obtains Cookies with the consent of the Customers and analyzes the combination of the Customer&apos;s &quot; TRIAL Member ID &quot;, browsing history of TRIAL Group Websites, shopping history at TRIAL Group, service usage history, etc., to propose products and services, etc. that match the interests and preferences of the Customers and to provide information, marketing research, and advertising distribution.
        </p>
        <p>
          Cookie is a mechanism for storing information about users who access the website.
          If you wish to opt out of Cookies, please click
          <LinkText path="/en/cookie-management" text=" here" />
          .
        </p>
      </>
    ),
    id: 'privacy7',
  },
  {
    children: (
      <>
        <h3>
          8. Requests for Disclosure, Correction, Addition, Deletion, or Suspension of Personal Information by Customers
        </h3>
        <StyledList liWidth="960" marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            Customers may request the disclosure, correction, addition, deletion, or suspension of personal information registered by the Customers in a manner prescribed by TRIAL Group through the &quot;13. Contact for Inquiries about Personal Information &quot; section of the Privacy Policy. However, please note that we may not be able to disclose all or part of the personal information in the following cases.
            <br />
             ① Cases in which disclosure may harm the life, body, property, and other rights and interests of the Customers or third parties.
            <br />
             ② Cases in which disclosure may cause significant hindrance to the proper conduct of TRIAL Group business.
            <br />
             ③ Cases in which disclosure may violate laws and regulations.
          </StyledListItem>
          <StyledListItem listType="article">
            TRIAL Group shall quickly respond to requests for disclosure made by Customers and promptly correct any information that is found to be incorrect because of such requests. In such cases, from the standpoint of strict management of personal information, TRIAL Group may ask the disclosure requester to present documents proving the identity. Please also understand that the fees for the disclosure of personal information prescribed by TRIAL Group may be asked to be paid.
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'privacy8',
  },
  {
    children: (
      <>
        <h3>9. Handling of EU and UK Resident Data</h3>
        <p>
          In accordance with EU General Data Protection Regulation and its equivalent UK legislation (hereinafter collectively referred to as &quot;GDPR&quot;), this Article applies only to the handling of information that identifies or may identify persons residing in the European Union (in this Article, including Iceland, Liechtenstein and Norway, hereinafter referred to as &quot;EU&quot;) and the United Kingdom (hereinafter referred to as &quot;EU and UK Resident Data&quot;; natural persons who are the subject of such EU and UK Resident Data are referred to as &quot;EU and UK Resident Data Subjects&quot;). The provisions of the Privacy Policy also apply to EU and UK Resident Data, except for &quot;10. Handling of Personal Information of Residents of the State of California, U.S.A.&quot;.
        </p>
        <StyledList liWidth="960" marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            EU and UK Resident Data collected by TRIAL Group and with whom it is shared are as follows. Please note that TRIAL Group does not sell EU and UK Resident Data. 
          </StyledListItem>
        </StyledList>
        <GridTable>
          <GridRow>
            <div>EU and UK Resident Data Categories and Examples</div>
            <div>Categories of Information Sources</div>
            <div>Business or Commercial Purposes of Use</div>
            <div>Categories of Third Parties with Whom EU and UK Resident Data is Shared</div>
          </GridRow>
          <GridRow>
            <div>
              <StyledListInGridRow paddingLeft="0.5">
                <StyledListItem listType="disc">
                  Personal identification information (name, e-mail address, etc.).
                </StyledListItem>
                <StyledListItem listType="disc">
                  Information regarding the place of employment or affiliation (company, corporation, department, position, etc.).
                </StyledListItem>
              </StyledListInGridRow>
            </div>
            <div>Direct collection from the EU and UK Resident Data Subjects.</div>
            <div>Exchange of information, etc.</div>
            <div>Shall not be shared.</div>
          </GridRow>
          <GridRow>
            <div>
              Information about Internet and other network activities (information collected by Cookies; if you wish to opt out of the Cookies, please click
              <LinkText path="/cookie-management" text=" here" />
              ).
            </div>
            <div>
              Collection through browsing and using TRIAL Group&apos;s Websites.
            </div>
            <div>Confirmation of access history, etc.</div>
            <div>
              TRIAL Group (Click 
              <LinkText path="/company/overview/" text=" here" />
              for information on TRIAL Group companies other than TRIAL Holdings, Inc.).

            </div>
          </GridRow>
        </GridTable>
        <StyledList
          liWidth="960"
          marginLeft="0.5"
          paddingLeft="0.5"
          startValue={1}
        >
          <StyledListItem listType="article">
            When TRIAL Group handles EU and UK Resident Data as a controller under the GDPR (i.e. a person who determines how and for what purposes EU and UK Resident Data is handled), TRIAL Group shall clearly inform the EU and UK Resident Data Subjects of the purpose of the handling of EU and UK Resident Data and any other required GDPR notices, and obtain consent from the EU and UK Resident Data Subjects for such handling, unless there is a legal basis for otherwise.
          </StyledListItem>
          <StyledListItem listType="article">
            The explanation at the time of obtaining consent in the preceding paragraph shall be clearly stated in a manner that is clearly distinguishable from other matters, using clear and plain language, and in a manner that is easily understood and readily accessible.
          </StyledListItem>
          <StyledListItem listType="article">
            TRIAL Group shall maintain records of consent to the handling of EU and UK Resident Data obtained from EU and UK Resident Data Subjects to be able to present proof of such consent in case it is requested.
          </StyledListItem>
          <StyledListItem listType="article">
            TRIAL Group shall retain the EU and UK Resident Data listed in the table (1) if it is necessary for the &quot;Business or Commercial Purposes of Use&quot; listed in the table. If legal or accounting regulations require or permit retention for a longer period than is necessary, the retention period shall be determined after taking into consideration the business needs of TRIAL Group.
          </StyledListItem>
          <StyledListItem listType="article">
            EU and UK Resident Data Subjects may receive their EU and UK Resident Data from TRIAL Group in a structured, commonly used, and machine-readable format and may transfer the received EU and UK Resident Data to other controllers without hindrance by TRIAL Group.
          </StyledListItem>
          <StyledListItem listType="article">
            EU and UK Resident Data Subjects have the right to withdraw their consent at any time to the handling of the EU and UK Resident Data by TRIAL Group. The lawfulness of TRIAL Group&apos;s handling of EU and UK Resident Data shall not be affected by the withdrawal of consent by the EU and UK Resident Data Subjects.
          </StyledListItem>
          <StyledListItem listType="article">
            TRIAL Group may transfer EU and UK Resident Data to countries outside the EU and the UK (including Japan) for handling. Japan has been granted an adequacy decision  by the European Commission recognizing that personal data protection in Japan is adequately ensured. Although transfer countries other than Japan, the EU, and the UK may not have the same privacy legislation as the country in which the EU and UK Resident Data Subject resides, TRIAL Group protects EU and UK Resident Data by entering standard contractual clauses based on GDPR with the data transfer recipient.
          </StyledListItem>
          <StyledListItem listType="article">
            If TRIAL Group handles EU and UK Resident Data as a processor under the GDPR (which means the subject acting on the written instructions by the controller), TRIAL Group shall handle such EU and UK Resident Data appropriately in accordance with the instructions by the controller of such EU and UK Resident Data.
          </StyledListItem>
          <StyledListItem listType="article">
            EU and UK Resident Data Subjects who wish to make inquiries concerning EU and UK Resident Data handled by TRIAL Group as a controller for those relating to the exercise of rights, etc. granted to data subjects under the GDPR, please contact us with the contact information in &quot;13. Contact for Inquiries about Personal Information&quot; of the Privacy Policy. When responding to the request, we shall need to confirm the identity of the data subject or the data subject&apos;s representative.
          </StyledListItem>
          <StyledListItem listType="article">
            TRIAL Group shall respond in accordance with the provisions of the GDPR in the event that the data subject exercises any rights, etc. granted to it under the GDPR with respect to EU and UK Resident Data that TRIAL Group handles as a controller under the GDPR.
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'privacy9',
  },
  {
    children: (
      <>
        <h3>
          10. Handling of Personal Information of Residents of the State of California, U.S.A.
        </h3>
        <p>
          In accordance with the California Consumer Privacy Act (hereinafter referred to as &quot;CCPA&quot;), this Article only applies to the handling of personal information (for the purpose of this Article, the information shall mean that identifies, relates to, describes, can be reasonably associated with, or can be reasonably linked directly or indirectly to, a particular consumer or household) of a resident of the State of California, U.S.A. The provisions of the Privacy Policy also apply to the personal information of residents of the State of California, USA, with the exception of &quot;9. Handling of EU and UK Resident Data&quot;.
        </p>
        <StyledList liWidth="960" marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="boldArticle">
          Collection and Use of Personal Information
            <p>
              Personal information collected by TRIAL Group from U.S. California residents during the past 12 months, the purposes for which it is used, and with whom it is shared are listed below. TRIAL Group does not sell and has not sold in the past 12 months, any personal information of U.S. residents of California (including personal information of minors) to the third parties. 
            </p>
          </StyledListItem>
        </StyledList>
        <GridTable>
          <GridRow>
            <div>
              Categories of Personal Information of the Residents of California, U.S.A and Examples
            </div>
            <div>Categories of Sources</div>
            <div>Business or commercial Purposes of Use</div>
            <div>
              Categories of Third Parties with Whom Personal Information of Residents of California, U.S.A.  is Shared
            </div>
          </GridRow>
          <GridRow>
            <div>
              <StyledListInGridRow paddingLeft="0.5">
                <StyledListItem listType="disc">
                  Personal identification information (name, e-mail address, etc.).
                </StyledListItem>
                <StyledListItem listType="disc">
                  Information regarding the place of employment or affiliation (company, corporation, department, position, etc.).
                </StyledListItem>
              </StyledListInGridRow>
            </div>
            <div>Direct collection from the residents of the State of California, U.S.A.</div>
            <div>Exchange of information, etc.</div>
            <div>Shall not be shared.</div>
          </GridRow>
          <GridRow>
            <div>
              Information about Internet and other network activities (information collected by Cookies; if you wish to opt out of the Cookies, please click 
              <LinkText path="/cookie-management" text=" here" />
              ).
            </div>
            <div>
              Collection through browsing and using TRIAL Group&apos;s Websites.
            </div>
            <div>Confirmation of access history, etc.</div>
            <div>
              TRIAL Group (Click
              <LinkText path="/company/overview/" text=" here" />
               for information on TRIAL Group companies other than TRIAL Holdings, Inc.).
            </div>
          </GridRow>
        </GridTable>
        <StyledList
          liWidth="960"
          marginLeft="0.5"
          paddingLeft="0.5"
          startValue={1}
        >
          <StyledListItem listType="boldArticle">
            Rights of Residents of the State of California, U.S.A.
            <br /> ① Right to Demand Disclosure
            <p>
              Residents of the State of California, U.S.A. have the right to request that TRIAL Group disclose the following information about their personal information collected, used, or shared by TRIAL Group in the past 12 months.
            </p>
            <StyledList marginLeft="1" paddingLeft="0.5">
              <StyledListItem listType="disc">
                Types of personal information collected.
              </StyledListItem>
              <StyledListItem listType="disc">
                Types of personal information collection methods.
              </StyledListItem>
              <StyledListItem listType="disc">
                Business or commercial purposes for which personal information is collected.
              </StyledListItem>
              <StyledListItem listType="disc">
                Types of personal information shared for business purposes.
              </StyledListItem>
              <StyledListItem listType="disc">
                Types of third parties with whom personal information is shared by type of personal information.
              </StyledListItem>
              <StyledListItem listType="disc">
                Specific personal information about the residents of the State of California, U.S.A. who made the disclosure request.
              </StyledListItem>
            </StyledList>
            ② Right of Deletion
            <p>
              Residents of the State of California, U.S.A. have the right to request certain personal information obtained by TRIAL Group be deleted.
            </p>
            ③ Right to Prohibit Discriminatory Treatment
            <p>
              TRIAL Group shall not discriminate against any residents of the State of California, U.S.A. on the basis of such residents&apos; exercise of rights under the CCPA. However, the deletion of personal information may result in the inability to provide the services that were previously available to you. Please understand this in advance.
            </p>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            Residents of the State of California, U.S.A. who wish to make inquiries concerning exercising their rights, etc. under the CCPA, please contact us with the contact information in &quot;13. Contact for Inquiries about Personal Information &quot; of the Privacy Policy. In responding to such requests, we shall need to confirm that the person making the request is the person in question or his/her representative.
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            In the event TRIAL Group receives an exercise of rights, etc. under the CCPA from the residents of the State of California, U.S.A., TRIAL Group shall respond in accordance with the provisions of the CCPA.
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'privacy10',
  },
  {
    children: (
      <>
        <h3>11. Disclaimer Regarding Links to Third-Party Companies</h3>
        <p>
          TRIAL Group is not responsible for matters relating to third-party companies that are not part of TRIAL Group and that are linked to this website. Such matters are governed by the terms and conditions and privacy policies of such companies.
        </p>
      </>
    ),
    id: 'privacy11',
  },
  {
    children: (
      <>
        <h3>12. Revisions to this Privacy Policy</h3>
        <p>
          TRIAL Group may change or revise the Privacy Policy from time to time to comply with the Personal Information Protection Acts. In the event of any changes or revisions to the Privacy Policy, the details of such changes or revisions will be posted on this website. Please review the Privacy Policy carefully after such changes or revisions have been made.
        </p>
      </>
    ),
    id: 'privacy12',
  },
  {
    children: (
      <>
        <h3>13. Contact for Inquiries about Personal Information</h3>
        <p>
          If you have any questions about the Privacy Policy, or if you have any questions or concerns about TRIAL Group&apos;s handling of personal information, please contact us at the contact information below.
        </p>
      </>
    ),
    id: 'privacy13',
  },
  {
    children: (
      <>
        <p>
          <span>
            Customer Service Center,
            <ZenkakuSpace />
            TRIAL Company, Inc.（Reception hours: 9:00 a.m. to 10:00 p.m. ）
          </span>
          <br />
           TEL:0120-033-559
          <br />
           Click <LinkText path="/contact/" text="here" /> for our web contact form.
          <br />
          <br />
          <span>
            [For inquiries regarding SEIYU]（Reception hours: 9:00 a.m. to 10:00 p.m. (except during the New Year holidays)）
          </span>
          <br />
          <span>
            SEIYU Customer Service Center 
          </span>
          <br />
          TEL : 0120-360-373
          <br />
          Click <a href="https://www.seiyu.co.jp/contact/" target="_blank" rel="noreferrer">here</a> for our web contact form.
          <br />
          <br />
          <span>
            “SEIYU.com Gift-kan” Customer Service Center,
          </span>
          <br />
          (Inquiries regarding the use of SEIYU.com Gift Store)
          <br />
          Click <a href="https://gift.the-seiyu.com/ec/guestInquiryEdit.html" target="_blank" rel="noreferrer">here</a> for our web contact form.
          <br />
          <br />
          Date of Enactment :
          December 26, 2022
          <br />
          Date of Last Revision :
          February 16, 2026
        </p>
      </>
    ),
    id: 'privacy14',
  },
]

export const pvLinks: {
  name: string
  anchor: string
}[][] = [
  [
    {
      name: '（ Collection and Management of Personal Information）',
      anchor: 'privacy1',
    },
    {
      name: '（Purpose of Use）',
      anchor: 'privacy2',
    },
    {
      name: '（Jointly Utilization of Personal Information）',
      anchor: 'privacy3',
    },
    {
      name: '（Provision to Third Partie）',
      anchor: 'privacy4',
    },
    {
      name: '（ Provision to Third Parties Located in Foreign Countries）',
      anchor: 'privacy5',
    },
    {
      name: '（Use of Anonymously Processed Information）',
      anchor: 'privacy6',
    },
    {
      name: '（ Use of Cookies）',
      anchor: 'privacy7',
    },
  ],
  [
    {
      name: '（Requests for Disclosure, Correction, Addition, Deletion, or Suspension of Personal Information by Customers）',
      anchor: 'privacy8',
    },
    {
      name: '（Handling of EU and UK Resident Data）',
      anchor: 'privacy9',
    },
    {
      name: '（Handling of Personal Information of Residents of the State of California, U.S.A.）',
      anchor: 'privacy10',
    },
    {
      name: '（Disclaimer Regarding Links to Third-Party Companies）',
      anchor: 'privacy11',
    },
    {
      name: '（ Revisions to this Privacy Policy)',
      anchor: 'privacy12',
    },
    {
      name: '（Contact for Inquiries about Personal Information)',
      anchor: 'privacy13',
    },
  ],
]


//  外部送信ポリシー(External transmission)

export const etItems: { children: ReactNode; id: string }[] = [
  {
    children: (
      <>
        <h3>1. Introduction</h3>
        <p>
          In the smartphone application operated by TRIAL Group, &quot;TRIAL+&quot;, &quot;SU-PAY&quot; (including services provided in conjunction with &quot;SU-PAY&quot;; hereinafter collectively referred to as the &quot;Service&quot;), and on the sites mentioned in &quot;3. Regarding External Transmission,&quot; we may use cookies and similar technologies to understand usage patterns, enhance convenience, perform statistical data analysis, and deliver, display, and measure the effectiveness of advertisements. For these purposes, information about users may be transmitted from the user&apos;s device to a server other than the user (&quot;External Transmission&quot;).
        </p>
        <p>
          In providing the Service, TRIAL Group, respecting privacy, may externally transmit user information (hereinafter referred to as &quot;User Information&quot;), such as user identifiers stored in cookies and device OS information, to the operators providing external services (hereinafter referred to as &quot;External Services&quot;) necessary for the use of the external services.
        <br />
          *Note: Cookies are text data stored on the user&apos;s device through the browser when accessing the Service.
        </p>
      </>
    ),
    id: 'privacy1',
  },

  {
    children: (
      <>
        <h3>2. Opt-out Measures (Discontinuation of External Transmission)</h3>
        <p>
          Customers,etc. may, through browser settings, choose to discontinue external transmission. Please note that making such a choice may affect the normal use of the Service.
        </p>
      </>
    ),
    id: 'privacy2',
  },

  {
    children: (
      <>
        <h3>3. Regarding External Transmission</h3>
        <p>
          Information to be disclosed based on the External Transmission regulations of the Telecommunications Business Law (Article 27-12 of the Telecommunications Business Law) and requests from external service providers serving as transmission destinations, related to external services currently used by TRIAL Group for external transmission, is as follows. Please check the link in the &quot;Privacy Policy of the Transmission Destination&quot; for information on the purposes of using transmitted user information at the destination.
        </p>
        
        <GridTable2>
          <GridRow>
            <div>Target Website(s) or Equivalent</div>
            <div>Recipient Business/Service Name</div>
            <div>Content of the Transmitted Information</div>
            <div>Intended Use of the Transmitted Information by Our Company</div>
            <div>Privacy Policy or Equivalent of the Recipient</div>
            <div>Settings for Discontinuing External Transmission, etc.</div>
          </GridRow>
          <GridRow>
            <div><a href="https://trial-holdings.inc/" target="_blank" rel="noreferrer">https://trial-holdings.inc/</a>
              <br /><a href="https://www.trial-net.co.jp/" target="_blank" rel="noreferrer">https://www.trial-net.co.jp/</a></div>
            <div>Plaid/KARTE</div>
            <div>
              <StyledListInGridRow paddingLeft="0.5">
                <StyledListItem listType="disc">
                  Viewing history of pages within the site
                </StyledListItem>
                <StyledListItem listType="disc">
                  Duration of stay on each page
                </StyledListItem>
                <StyledListItem listType="disc">
                  Browser and OS type/version
                </StyledListItem>
                <StyledListItem listType="disc">
                  Screen size<br />Referrer
                </StyledListItem>
                <StyledListItem listType="disc">
                  Access source
                </StyledListItem>
                <StyledListItem listType="disc">
                  Conversion data during form submission
                  <br />Advertising, marketing, and usage analysis
                </StyledListItem>
              </StyledListInGridRow>
            </div>
            <div>Advertising, Marketing, Usage Analysis</div>
            <div><a href="https://karte.io/karte-policy.html" target="_blank" rel="noreferrer">https://karte.io/karte-policy.html</a></div>
            <div><a href="https://karte.io/optout/" target="_blank" rel="noreferrer">https://karte.io/optout/</a></div>
          </GridRow>
          <GridRow>
            <div><a href="https://trial-holdings.inc/" target="_blank" rel="noreferrer">https://trial-holdings.inc/</a>
                 <br /><a href="https://www.trial-net.co.jp/" target="_blank" rel="noreferrer">https://www.trial-net.co.jp/</a></div>
            <div>Google LLC/Firebase</div>
            <div>The content of the acquired information: <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noreferrer">https://policies.google.com/technologies/partner-sites</a></div>
            <div>Access Analysis </div>
            <div><a href="https://firebase.google.com/support/privacy?hl=ja#firebase_data_processing_and_security_terms" target="_blank" rel="noreferrer">https://firebase.google.com/support/privacy?hl=ja#firebase_data_processing_and_security_terms</a></div>
            <div><a href="https://support.google.com/firebase/answer/9019185?hl=ja#zippy=%2C%E3%81%93%E3%81%AE%E8%A8%98%E4%BA%8B%E3%81%AE%E5%86%85%E5%AE%B98248?hl=ja" target="_blank" rel="noreferrer">https://support.google.com/firebase/answer/9019185?hl=ja#zippy=%2C%E3%81%93%E3%81%AE%E8%A8%98%E4%BA%8B%E3%81%AE%E5%86%85%E5%AE%B98248?hl=ja</a></div>
          </GridRow>
          <GridRow>
            <div><a href="https://trial-holdings.inc/" target="_blank" rel="noreferrer">https://trial-holdings.inc/</a>
                <br /><a href="https://www.trial-net.co.jp/" target="_blank" rel="noreferrer">https://www.trial-net.co.jp/</a></div>
            <div>Intimatemerger</div>
            <div>
              <StyledListInGridRow paddingLeft="0.5">
                <StyledListItem listType="disc">
                  Unique ID stored in cookies
                </StyledListItem>
                <StyledListItem listType="disc">
                  Date and time of visit to the site or exposure to an advertisement
                </StyledListItem>
                <StyledListItem listType="disc">
                  URL of the visited site
                </StyledListItem>
                <StyledListItem listType="disc">
                  Title and meta keywords of the visited site
                </StyledListItem>
                <StyledListItem listType="disc">
                  Referrer at the time of the visit
                </StyledListItem>
                <StyledListItem listType="disc">
                  IP address of the access source
                </StyledListItem>
                <StyledListItem listType="disc">
                  User agent of the browser
                </StyledListItem>
                <StyledListItem listType="disc">
                  Language setting and character encoding setting of the browser
                </StyledListItem>
                <StyledListItem listType="disc">
                  Display area and color depth of the browser
                </StyledListItem>
              </StyledListInGridRow>
            </div>
            <div>Delivery of content based on location information, acquisition of marketing information through understanding usage patterns, and service improvement.</div>
            <div><a href="https://corp.intimatemerger.com/privacypolicy/" target="_blank" rel="noreferrer">https://corp.intimatemerger.com/privacypolicy/</a></div>
            <div><a href="https://corp.intimatemerger.com/privacypolicy/" target="_blank" rel="noreferrer">https://corp.intimatemerger.com/privacypolicy/</a></div>
          </GridRow>
          <GridRow>
            <div>
              SU-PAY
              <br />
              TRIAL＋
            </div>
            <div>unerry Inc.</div>
            <div>
             <StyledListInGridRow paddingLeft="0.5">
                <StyledListItem listType="disc">
                  Device information such as smartphone model, manufacturer, device OS version, and language settings
                </StyledListItem>
                <StyledListItem listType="disc">
                  Advertising identifier (IDFA or Google Advertising ID, etc.).
                </StyledListItem>
                <StyledListItem listType="disc">
                  Location information related to smartphones.
                </StyledListItem>
                <StyledListItem listType="disc">
                  Information about beacons acquired by the app users in the vicinity.
                </StyledListItem>
                <StyledListItem listType="disc">
                  IP address.
                </StyledListItem>
                <StyledListItem listType="disc">
                  Information related to the usage of this app (permission for location information usage, status of Bluetooth (on/off), viewing and opening date/time of push content, information about reacted beacons, etc.).
                </StyledListItem>
                <StyledListItem listType="disc">
                  Segment information of app users determined as necessary by the provider of this app (age, gender, occupation, etc., excluding personal information).
                  <br /> *For more details, please refer to <a href="https://su-pay.jp/terms/" target="_blank" rel="noreferrer">https://su-pay.jp/terms/</a>.
                </StyledListItem>
              </StyledListInGridRow>
            </div>
            <div>Delivery of content based on location information, acquisition of marketing information through understanding usage patterns, and service improvement. </div>
            <div><a href="https://www.unerry.co.jp/privacy/" target="_blank" rel="noreferrer">https://www.unerry.co.jp/privacy/</a></div>
            <div><a href="https://www.unerry.co.jp/privacy/" target="_blank" rel="noreferrer">https://www.unerry.co.jp/privacy/</a></div>
          </GridRow>
          <GridRow>
            <div>
              <a href="https://miyawaka-toranoyu.com/" target="_blank" rel="noreferrer">https://miyawaka-toranoyu.com/</a>
              <br />
              <a href="https://kominka-neri.com/" target="_blank" rel="noreferrer">https://kominka-neri.com/</a>
              <br />
              <a href="https://toranoyu.com/" target="_blank" rel="noreferrer">https://toranoyu.com/</a>
              <br />
              <a href="https://www.kuoritei.com/" target="_blank" rel="noreferrer">https://www.kuoritei.com/</a>
              <br />
              <a href="https://www.sengokuharatoranoyu.com/" target="_blank" rel="noreferrer">https://www.sengokuharatoranoyu.com/</a>
              <br />
              <a href="https://hakonekuoritei.com/" target="_blank" rel="noreferrer">https://hakonekuoritei.com/</a>
            </div>
            <div>Microsoft Corporation/ Clarity</div>
            <div>
             <StyledListInGridRow paddingLeft="0.5">
                <StyledListItem listType="disc">
                  Viewing history of the websites (date/time, URL, category, referrer, etc.)
                </StyledListItem>
                <StyledListItem listType="disc">
                  Location information of the device (IP address, GPS info, etc.)
                </StyledListItem>
                <StyledListItem listType="disc">
                  Information identifying the user or device (User ID, browser/device identifier, etc.)
                </StyledListItem>
              </StyledListInGridRow>
            </div>
            <div>Analysis of website viewing status</div>
            <div><a href="https://privacy.microsoft.com/ja-jp/privacystatement" target="_blank" rel="noreferrer">https://privacy.microsoft.com/ja-jp/privacystatement</a></div>
            <div>―</div>
          </GridRow>
        </GridTable2>
        <p>Additionally, in addition to the external transmissions listed above, TRIAL Group also externally transmit information necessary for providing the Service. This includes, but is not limited to, information required for tasks such as retaining entered information, user authentication, security measures for detecting and preventing unauthorized access, information necessary for network management such as detecting and addressing malfunctions or errors, and more.</p>
        <p>
          Date of Enactment : September 05, 2023
          <br />
          Date of Last Revision : February 16, 2026
        </p>
      </>
    ),
    id: 'privacy3',
  },
]
